
import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { useKits } from "@/hooks/useKits";
import { KitHeader } from "@/components/kit/KitHeader";
import { KitControlLayout } from "@/components/kit/KitControlLayout";
import { KitControlContent } from "@/components/kit/KitControlContent";
import { TSPEvent } from "@/types/tsp";
import { toast } from "sonner";

type ViewMode = "ticker" | "scoreboard";

export default function KitControl() {
  const { id } = useParams();
  const { kits } = useKits();
  const [viewMode, setViewMode] = useState<ViewMode>("ticker");
  const [selectedGame, setSelectedGame] = useState<TSPEvent | undefined>();
  const [isHeaderCollapsed, setIsHeaderCollapsed] = useState(false);
  
  const kit = kits.find(k => k.id === id);

  if (!kit) {
    return null;
  }

  const handleGameSelect = (game: TSPEvent) => {
    setSelectedGame(game);
    setIsHeaderCollapsed(true);
    toast.success(`Selected game: ${game.meta.event_away_team_abbreviation} vs ${game.meta.event_home_team_abbreviation}`);
  };

  return (
    <KitControlLayout>
      <KitHeader
        kitNumber={kit.number}
        viewMode={viewMode}
        selectedGame={selectedGame}
        isHeaderCollapsed={isHeaderCollapsed}
        onViewModeChange={setViewMode}
        onHeaderCollapse={setIsHeaderCollapsed}
      />
      <KitControlContent
        kitId={kit.id}
        kitNumber={kit.number}
        viewMode={viewMode}
        selectedGame={selectedGame}
        isHeaderCollapsed={isHeaderCollapsed}
      />
    </KitControlLayout>
  );
}
